import { FormArray } from '@angular/forms';
var TabCustomFieldsComponent = /** @class */ (function () {
    function TabCustomFieldsComponent() {
    }
    return TabCustomFieldsComponent;
}());
export { TabCustomFieldsComponent };
